module.exports = __webpack_public_path__ + "static/media/checkedIcon.8f5ed405.svg";